import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZoteroComponent } from './simple-icons-zotero.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZoteroComponent ],
    exports:      [ SimpleIconsZoteroComponent ],
    bootstrap:    []
})
export class SimpleIconsZoteroModule {}
